module.exports = __webpack_public_path__ + "img/study-follow-icon1.420c0f86.png";